module.exports = __webpack_public_path__ + "static/media/criacao-elementos-img-01.afc4ace2.svg";